// extracted by mini-css-extract-plugin
var _1 = "FollowUpRow-moduleFollowUpRow__hKEQF";
var _2 = "FollowUpRow-moduleassignees__EobNF";
var _3 = "FollowUpRow-modulelabel__wTraA";
var _4 = "FollowUpRow-moduletitle__QLBxk";
export { _1 as "FollowUpRow", _2 as "assignees", _3 as "label", _4 as "title" }
